import {themes} from "../contexts/ThemeContext";
import {backgroundColors} from "../contexts/BackgroundColorContext";
import colors from "../styles/colors";

export interface ChartThemeColors {
  primary: string;
  secondary: string;
  background: string;
  text: string;
  grid: string;
  accent: string;
  surface: string;
  border: string;
  tooltip: {
    background: string;
    text: string;
    border: string;
  };
}

export interface ChartThemeConfig {
  mode: keyof typeof themes;
  colors: ChartThemeColors;
  backgroundColorMode: keyof typeof backgroundColors;
  customColors: typeof colors;
}

export interface ThemeAwareChartProps {
  theme?: ChartThemeConfig;
  inheritTheme?: boolean;
}

export interface ColorScheme {
  default: string[];
  categorical: string[];
  sequential: string[];
  diverging: string[];
}

export interface ChartColorMapping {
  [key: string]: {
    light: ColorScheme;
    dark: ColorScheme;
  };
}

export const defaultChartColors: ChartColorMapping = {
  performance: {
    light: {
      default: [colors.brand, colors.green, colors.orange, colors.tacxblue],
      categorical: [colors.brand, colors.green, colors.orange, colors.tacxblue, colors.purple, colors.fiestared],
      sequential: [colors.lightblue, colors.tacxblue, colors.wahooblue],
      diverging: [colors.fiestared, colors.yellow, colors.green]
    },
    dark: {
      default: [colors.lightblue, colors.seafoamgreen, colors.yellowborder, colors.tacxblueborder],
      categorical: [
        colors.lightblue,
        colors.seafoamgreen,
        colors.yellowborder,
        colors.tacxblueborder,
        colors.lavender,
        colors.salmonpinkborder
      ],
      sequential: [colors.sonicblueborder, colors.tacxblueborder, colors.lightblue],
      diverging: [colors.fiestaredborder, colors.yellowborder, colors.greenborder]
    }
  },
  network: {
    light: {
      default: [colors.tacxblue, colors.sonicblue, colors.steel],
      categorical: [colors.tacxblue, colors.sonicblue, colors.steel, colors.lightblue],
      sequential: [colors.lightblue, colors.sonicblue, colors.tacxblue],
      diverging: [colors.fiestared, colors.yellow, colors.tacxblue]
    },
    dark: {
      default: [colors.tacxblueborder, colors.sonicblueborder, colors.lightblue],
      categorical: [colors.tacxblueborder, colors.sonicblueborder, colors.lightblue, colors.tacxbluemuted],
      sequential: [colors.sonicblueborder, colors.tacxblueborder, colors.lightblue],
      diverging: [colors.fiestaredborder, colors.yellowborder, colors.tacxblueborder]
    }
  },
  latency: {
    light: {
      default: [colors.green, colors.yellow, colors.orange, colors.fiestared],
      categorical: [colors.green, colors.yellow, colors.orange, colors.fiestared],
      sequential: [colors.green, colors.yellow, colors.orange],
      diverging: [colors.green, colors.yellow, colors.fiestared]
    },
    dark: {
      default: [colors.greenborder, colors.yellowborder, colors.orangeborder, colors.fiestaredborder],
      categorical: [colors.greenborder, colors.yellowborder, colors.orangeborder, colors.fiestaredborder],
      sequential: [colors.greenborder, colors.yellowborder, colors.orangeborder],
      diverging: [colors.greenborder, colors.yellowborder, colors.fiestaredborder]
    }
  }
};

export type ChartColorCategory = keyof typeof defaultChartColors;
export type ColorSchemeType = keyof ColorScheme;
